module.exports = __webpack_public_path__ + "static/banner_nive-87e5a98fa318a37a6a201f0b4400396f.png";